'use client'

import React, { createContext, use } from 'react'

import type { Locale } from './types'

export interface LocaleContextType {
    locale: Locale
}

const initialContext: LocaleContextType = {
    locale: 'en',
}

const LocaleContext = createContext(initialContext)

export const LocaleProvider = ({ children, locale }: { children: React.ReactNode; locale: Locale }) => {
    return <LocaleContext value={{ locale }}>{children}</LocaleContext>
}

export const useLocale = (): LocaleContextType => use(LocaleContext)
